import { useEffect } from 'react';

const usePreventBodyScroll = shouldPreventScroll => {
  useEffect(() => {
    if (shouldPreventScroll) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    // Make sure to unset on route change
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [shouldPreventScroll]);
};

export default usePreventBodyScroll;
